module.exports = __webpack_public_path__ + "img/video_menu_video_off.be8ab7a1.svg";